import React, { FC, useCallback, useContext, useMemo } from 'react';
import AnimatedCard from '../../../AnimatedCard';
import styles from './index.module.scss';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { observer } from 'mobx-react-lite';

const NolCouponCard: FC = () => {
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v8/${path}`), []);
  const store = useContext(NolPromotionStoreCtx);

  const nolPointCardProps = useMemo(() => {
    return {
      type: 'gray' as const,
      supTitle: <div className={styles.cardSupTitle}>카드 혜택 1</div>,
      title: (
        <div className={styles.cardTitle}>
          NOL 포인트 <br /> <span className={styles.blue}>10% 적립</span>
        </div>
      ),
      image: (
        <img
          className={styles.nolPointImage}
          src={getResourcePath('nol-point.png')}
          alt={'NOL 카드 전용 10% 쿠폰 5장'}
        />
      ),
      description: {
        bold: '여행 · 커피전문점 · 대중교통 · 해외가맹점 포함',
        normal:
          '· 전월 실적 40만원 이상 충족 시 최대 2만 5천P 적립\n· 전월 실적 80만원 이상 충족 시 최대 3만 6천P 적립',
      },
    };
  }, []);

  return (
    <AnimatedCard
      className={styles.cardPoint}
      {...nolPointCardProps}
      onDetailClick={() => (store.isPointBottomSheetOpen = true)}
      logData={{
        object: '자세히 보기',
        objectType: 'Btn',
        objectContainer: 'NOL에서 놀때는 NOL 카드',
        motherPageVersion: store.version,
        motherPageSectionType: '혜택',
        motherPageSectionName: 'NOL 포인트 10% 적립',
        deepLinkUri: '',
      }}
    />
  );
};

export default observer(NolCouponCard);
